import { useToken, Heading } from '@chakra-ui/react';
import { FC } from 'react';

import { TagVariant } from '@/resources/Tag';

interface ILectureCardTagProps {
  tagItem?: { name: string; variant: TagVariant };
}

export const LectureCardTag: FC<ILectureCardTagProps> = ({ tagItem }) => {
  const [primary, secondary, tertiary, quaternary, quinary] = useToken('colors', [
    'violet.500',
    'teal.500',
    'blue.500',
    'pink.500',
    'almostRed.500',
  ]);

  const tagColorDictionary: Record<TagVariant, string> = {
    primary,
    secondary,
    tertiary,
    quaternary,
    quinary,
  };

  return (
    <Heading
      as="div"
      role="doc-subtitle"
      mb="2"
      textTransform="uppercase"
      fontSize="sm"
      lineHeight="base"
      letterSpacing=".05em"
      color={tagColorDictionary[tagItem?.variant]}
    >
      {tagItem?.name}
    </Heading>
  );
};
